import Link from "next/link";
import { Zap } from "lucide-react";

import { track } from "@/lib/analytics";
import type { BlogTopic } from "@/lib/blog/topics";

export const BlogCta = ({ topic }: { topic?: BlogTopic }) => {
  const href = topic?.featureHref ?? "/";
  const label = topic?.ctaLabel ?? "Try Crayo free";
  const headline = topic ? `${topic.name}, powered by Crayo` : "Create viral shorts with Crayo";

  return (
    <section className="w-full">
      <div className="flex flex-col items-start gap-4 rounded-2xl bg-gray-900 p-6 sm:flex-row sm:items-center sm:justify-between sm:p-8">
        <div className="space-y-1.5">
          <h2 className="text-lg font-semibold text-white sm:text-xl">{headline}</h2>
          <p className="max-w-md text-sm leading-normal text-white/70">
            Turn a script, a clip, or a rough idea into a finished short form video in minutes. No
            editing skills required.
          </p>
        </div>
        <Link
          href={href}
          onClick={() => track("cta_clicked", { cta: "blog_post_cta", href })}
          className="flex shrink-0 items-center gap-2 rounded-xl bg-[#2A66FF] px-5 py-3 text-sm font-medium text-white transition duration-200 ease-in-out hover:opacity-90"
        >
          <Zap className="h-[1em] w-auto fill-white text-white" />
          {label}
        </Link>
      </div>
    </section>
  );
};
